module.exports = __webpack_public_path__ + "static/img/37.e3310c78.png";